<!-- 关系图 -->
<template>
  <div>
      <div class="chart_Title" style="width:100%;align-items: center;" :style = "{ background: 'url(' +commenUrl+ baseConfig.title?.textRgb + ') no-repeat',backgroundSize:'100%',display:baseConfig?.title?.textShow?'flex':'none', height: baseConfig.title?.Height + 'px'}">
          <div class="img-icon" :style = "{ width: baseConfig.title?.textWidth + 'px', height: baseConfig.title?.textHeight + 'px', marginLeft: baseConfig.title?.textLeft + 'px', marginRight: baseConfig.title?.textRight + 'px',display:baseConfig?.title?.textIcon?'block':'none'}">
              <img style="height:100%;width:100%" :src="commenUrl+baseConfig?.title?.textIcon" alt="">
          </div>
          <div style="flex:1" :style = "{ fontSize: baseConfig.title?.textSzie + 'px', color: baseConfig.title?.textColor,textAlign: baseConfig.title?.textAlign}">{{baseConfig?.title?.textTitle}}</div>
      </div>
      <div class="parelchartbox" id='parelchartbox' :class="baseConfig.animation"  :style = "{ width: baseConfig.width + 'px', height: baseConfig.height + 'px'}">
        <div  class="chartParel" ref='parelchartRef' :style = "{ left: baseConfig.left + 'px',top: baseConfig.top + 'px'}"></div>
      </div>
    </div>

</template>




<script>
import { getCurrentInstance,ref,onMounted,onUnmounted,watch,shallowRef,computed } from "vue";
import * as echarts from 'echarts';
import { useStore } from 'vuex';
import { colorCustomMerge, cloneDeep  } from '../../../utils'
export default {
  props: {
      index: {
          type:Number ,
          default: function () { return {} }
      },
      yearRef:{
          type: String,
          default: function () { return "2024" }
      }
  },
  setup(props) {
     
      const { proxy } = getCurrentInstance();
      const store = useStore();
      const index = ref(props.index);
      const setProject = ref(computed(() => store.state.project.index));
      const canvasConfig = ref(computed(() => store.state.chartData.canvasConfig));
      const comChartColors = ref(colorCustomMerge())   //获取选中颜色

      const baseConfig = ref({})
      const componentList = ref(computed(() => store.state.chartData.componentList));
      baseConfig.value = componentList.value[index.value].config.baseConfig

      const option = ref({})
      const parelchartRef = shallowRef(null);
      const chartInstance = shallowRef(null);
      const handleResize = () => {
          chartInstance.value.resize();
      };

      const myGraphData = ref([])//总数据
      const listdata = ref([]);//需要
      const linksdata = ref([]);//需要
      const legendData = ref([])

 

      watch(() => store.state.chartData.componentList[index.value].config.options,(newVal, oldVal) => {
          //此时返回的是数组,按下标获取对应值
              if(newVal){
                  chartInit()
              }
          },{ deep: true }
      ) 
      watch(() => store.state.chartData.componentList[index.value].data,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
              if(newVal){
                  chartInit()
              }
          },{ deep: true }
      )
      watch(() => store.state.chartData.componentList[index.value].config.baseConfig,(newVal, oldVal) => {
          //此时返回的是数组,按下标获取对应值
              if(newVal){
                baseConfig.value = componentList.value[index.value].config.baseConfig
                setTimeout(()=>{
                  handleResize()
                })
              }
          },{ deep: true }
      ) 
      onMounted(() => {
          chartInstance.value = echarts.init(parelchartRef.value);
          chartInit() 
          window.addEventListener('resize', handleResize);
      });
      onUnmounted(() => {
          window.removeEventListener('resize', handleResize);
      });

      const chartInit = ()=>{
        chartInstance.value.clear()
        option.value = componentList.value[index.value].config.options

        const dataArr = JSON.parse(JSON.stringify(componentList.value[index.value].data))
        
        option.value.series[0].data = dataArr.dataAll
        option.value.series[0].data.forEach((item,index) =>{
          item.draggable = true
        })


        option.value.series[0].links = dataArr.links

        option.value.series[0].links.forEach((item,index) =>{
          item.lineStyle = {
            "normal": {
                "width": option.value.series[0].force.lineWidth,
                color:option.value.series[0].force.lineColor
            }
          }
        })

        option.value.series[0].categories = dataArr.categories

        legendData.value = []
        option.value.series[0].categories.forEach((item,index) =>{
          legendData.value.push(item.name)
          item.symbol = "circle"
          item.symbolSize = option.value.series[0].sizeList[index]
        })
        option.value.legend.data =legendData.value


        chartInstance.value.setOption(option.value);
      }


      return{
          option,
          parelchartRef,
          baseConfig,
          canvasConfig,
          comChartColors,
          setProject,
          legendData,
          listdata,
          linksdata,
      }
  }
}
</script>

<style scoped>
.parelchartbox {position: relative; }
.chartParel {
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>